import { useState, useEffect } from 'react';
import { getPublicVendors } from './api';

let cachedVendors = null;
let fetchPromise = null;

export function usePublicVendors() {
  const [vendors, setVendors] = useState(cachedVendors || []);
  const [loading, setLoading] = useState(!cachedVendors);

  useEffect(() => {
    if (cachedVendors) { setVendors(cachedVendors); setLoading(false); return; }
    if (!fetchPromise) {
      fetchPromise = getPublicVendors().then(data => {
        cachedVendors = data.vendors || [];
        return cachedVendors;
      }).catch(() => []);
    }
    fetchPromise.then(v => { setVendors(v); setLoading(false); });
  }, []);

  return { vendors, loading };
}
